import { Table, TableHead, TableRow, TableBody } from '@mui/material';
import {
  GeneralTableBox,
  HeadTableCell,
  RowTableCell,
  PaginationTable,
  LoadingSkeleton,
} from '../../../common/components';
import CashRetentionRow from './CashRetentionRow';

const CashRetentionsTable = ({
  movements = [],
  totalItems = 0,
  page = 1,
  totalPages = 1,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  isLoading,
  onEditMovement,
  onRefresh,
}) => (
  <GeneralTableBox>
    <Table stickyHeader size="small">
      <TableHead>
        <TableRow>
          <HeadTableCell>Fecha emisión</HeadTableCell>
          <HeadTableCell>Fecha venc.</HeadTableCell>
          <HeadTableCell>Tipo</HeadTableCell>
          <HeadTableCell>Concepto</HeadTableCell>
          <HeadTableCell>Comprobante</HeadTableCell>
            <HeadTableCell>Beneficiario</HeadTableCell>
            <HeadTableCell align="right">Importe</HeadTableCell>
            <HeadTableCell align="center">Acciones</HeadTableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {isLoading ? (
          <TableRow>
            <RowTableCell colSpan={8} align="center">
              <LoadingSkeleton />
            </RowTableCell>
          </TableRow>
        ) : movements.length ? (
          movements.map((movement) => (
            <CashRetentionRow
              key={movement.uuid}
              movement={movement}
              onEdit={onEditMovement}
              onRefresh={onRefresh}
            />
          ))
        ) : (
          <TableRow>
            <RowTableCell colSpan={8} align="center">
              No se encontraron movimientos sin cuenta bancaria.
            </RowTableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>

    {totalItems > rowsPerPage && (
      <PaginationTable
        page={page}
        totalPages={totalPages}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        totalCount={totalItems}
      />
    )}
  </GeneralTableBox>
);

export default CashRetentionsTable;
